module.exports = __webpack_public_path__ + "img/SkyPorchBalconyMap2.85b1a68d.jpg";